/* Mensaje Engraving FREE 


window.addEventListener('pplrAppInitiated' , function(e) {
  let button = $('.product-personalizer button.btn.pplr-c-button.pplr-btn.button.Button--secondary.ptc_button:not(.pplr_remove)').text('Add free custom engraving');
})

$(document).on("click",".product-personalizer button.btn.pplr-c-button.pplr-btn.button.Button--secondary.ptc_button.pplr_remove",function() {
  let button = $(this);
  $(button).css('color','white');
  setTimeout(function(){
    $(button).text('Add free custom engraving');
    $(button).css('color','black');
  }, 300);
});

*/


$(document).ready(function(){

  //ACTIVAR TODOS LOS VIDEOS
  $('.product-media-container.media-type-video deferred-media > button').click();
  
  // MENSAJE QUANTITY
  $(".quantity__input").on("change", function(){
      var nuevoValor = $(this).val();
      var message = $('.message-quantity-bulk a.icon-alert-qty > span');
  
      if(nuevoValor > 1){
          $('.message-quantity-bulk').slideDown();
      } else {
          $('.message-quantity-bulk').slideUp();
      };
      
      if(nuevoValor > 1 && nuevoValor < 5){
          var limit = 5 - nuevoValor;
          message.replaceWith('<span>Add ' + limit + ' more and get 15% off - </span>');
      } else if (nuevoValor > 4 && nuevoValor < 10){
          var limit = 10 - nuevoValor;
          message.replaceWith("<span><b>You've 15% OFF:</b> Add " + limit + " more and get 20% off - </span>");
      } else if (nuevoValor > 9 && nuevoValor < 15){
          var limit = 15 - nuevoValor;
          message.replaceWith("<span><b>You've 20% OFF:</b> Add " + limit + " more and get 30% off - </span>");
      } else if (nuevoValor > 14){
          message.replaceWith("<span><b>You've 30% OFF:</b> Add more than 15 and keep your 30% off - </span>");
      };
      
  });

  
  // DROPDOWN DESCRIPTIONS
  $('.description-product-accordion > li').first().addClass('active_description');
  $('.description-product-accordion > li > .description-product__answer').hide();
  $('.description-product-accordion > li.active_description > .description-product__answer').show();
  
  $('.description-product-accordion > li > h3').click(function() {
    var $open_description = $(this).parents('li');
    if ($($open_description).hasClass("active_description")) {
      $($open_description).removeClass("active_description").find(".description-product__answer").slideUp();
    } else {
      $(".description-product-accordion > li.active_description .description-product__answer").slideUp();
      $(".description-product-accordion > li.active_description").removeClass("active_description");
      $($open_description).addClass("active_description").find(".description-product__answer").slideDown();
    }
    return false;
  });


  //ESTILOS REVIEWS
  $('.okeReviews-widget-holder[data-oke-reviews-widget]').parents('.shopify-section.section').addClass('reviews-okendo-main-section');
  $('.reviews-okendo-main-section').prev('.shopify-section.section.text-rich-section').addClass('header-okendo-main-section');

  
  // MOVIMIENTO DE SHOPPAY
  $( '.product-form' ).append( $( '.form-shoppay' ) );

});